import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/events", label: "Events" },
  { to: "/records", label: "Records" },
  { to: "/partners", label: "Partners" },
  { to: "/about", label: "About" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-black border-b border-[#2a2a2a]" data-testid="site-header">
      <div className="max-w-[1400px] mx-auto px-5 lg:px-10 h-16 lg:h-20 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3" data-testid="brand-link" onClick={() => setOpen(false)}>
          <img src="/logo.png" alt="IVE — Ironveil Era" className="h-11 sm:h-12 w-auto" data-testid="brand-logo" />
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end}
              className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
              data-testid={`nav-${n.label.toLowerCase()}`}>{n.label}</NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <Link to="/register" className="hidden md:inline-flex btn-primary" data-testid="header-register-btn">Register</Link>
          <button className="lg:hidden text-white p-2 border border-[#2a2a2a]" onClick={() => setOpen((v) => !v)} data-testid="mobile-menu-toggle" aria-label="Toggle menu">
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="lg:hidden bg-black border-t border-[#2a2a2a]" data-testid="mobile-nav">
          <div className="px-5 py-6 flex flex-col gap-5">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)}
                className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`}
                data-testid={`mobile-nav-${n.label.toLowerCase()}`}>{n.label}</NavLink>
            ))}
            <Link to="/register" onClick={() => setOpen(false)} className="btn-primary w-full" data-testid="mobile-register-btn">Register</Link>
          </div>
        </div>
      )}
    </header>
  );
}
